// 销售与毛利报表接口
export const fetchSalesOverview = (params) => request.get('/admin/analytics/sales-overview', { params });

export const fetchSalesStats = () => request.get('/admin/stats/sales');
export const fetchProductStats = () => request.get('/admin/stats/products');
export const fetchOrderStats = () => request.get('/admin/stats/orders');
